import React, { useState, useEffect } from "react";
import AxiosInstance from "../../utils/AxiosInstance";
import { useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
// import MapComponent from "../maps/Maps";
import { useNavigate } from "react-router-dom";

export default function Showtutor(props) {
	const { slug } = useParams();
	const [tutor, setTutor] = useState();
	const navigate = useNavigate();
	const [residences, setResidences] = useState([]);
	const url = `${process.env.REACT_APP_API_URL}/api/images`;
	useEffect(() => {
		const fetchTutor = async () => {
			const res = await AxiosInstance({
				method: "get",
				url: `/api/v1/senior-tutors/${slug}`,
			});
			setTutor(res.data.data);
		};
		!tutor && fetchTutor();
	});

	const getMyResidences = async (zoneId) => {
		try {
			const res = await AxiosInstance({
				method: "get",
				url: `/api/v1/senior-tutors/zone/${zoneId}`,
			});
			setResidences(res.data.data);
		} catch (err) {}
	};
	// const handleDeActivate = async (id) => {
	// 	try {
	// 		const res = await AxiosInstance({
	// 			method: "patch",
	// 			url: `/api/v1/senior-tutors/de-activate/${id}`,
	// 		});
	// 		setTutor(res.data.data);
	// 	} catch (err) {
	// 		console.log(err);
	// 	}
	// };
	// const handleActivate = async (id) => {
	// 	try {
	// 		const res = await AxiosInstance({
	// 			method: "patch",
	// 			url: `/api/v1/senior-tutors/activate/${id}`,
	// 		});
	// 		setTutor(res.data.data);
	// 	} catch (err) {
	// 		console.log(err);
	// 	}
	// };
	return (
		<>
			<div className="page-container mb-3">
				<div className=" mx-5 my-5">
					<div className="col-md-11 col-sm-11">{/* <MapComponent /> */}</div>
				</div>
				<div className="tutor-card">
					<div className="row">
						{tutor && (
							<div className="col-md-3 col-sm-12">
								{tutor.image ? (
									<img
										src={`${url}/snr-tutors/${tutor.image}`}
										className="img-fluid"
										alt="..."
										style={{ width: 150, height: 130 }}
									/>
								) : (
									<img
										src={`${url}/snrtutors/PASSPORT_MTN.jpg`}
										className="img-fluid"
										alt="..."
										style={{ width: 150, height: 130 }}
									/>
								)}
								<div>
									<p className="tutor-name">
										{" "}
										<span className="mr-3">Name:</span>
										{tutor.name}
									</p>
									<p>
										<span className="mr-3">Contact:</span>
										{tutor.contact}
									</p>
									<p>
										<span className="mr-3">Zone:</span>
										{tutor.zone ? tutor.zone.name : "N/A"}
									</p>
								</div>
								<div>
									{/* { only visible to administrators only} */}
									{/* 									
									{tutor?.isCurrent ? (
										<Button
											onClick={() => handleDeActivate(tutor._id)}
											variant="danger"
										>
											De-Aactivate
										</Button>
									) : (
										<Button
											onClick={() => handleActivate(tutor._id)}
											variant="warning"
										>
											Activate
										</Button>
									)} */}
								</div>
							</div>
						)}
					</div>
				</div>
				{residences.length === 0 ? (
					<>
						<table>
							<thead>
								<tr>
									<th>ID</th>
									<th>Residence Name</th>
									<th>Location</th>
									<th>Zone</th>
									<th className="text-center">Actions</th>
								</tr>
							</thead>
						</table>

						<Button onClick={() => getMyResidences(tutor?.zone?._id)}>
							Get Residences
						</Button>
					</>
				) : (
					<table className="mt-4">
						<thead>
							<tr>
								<th>ID</th>
								<th>Residence Name</th>
								<th>Location</th>
								<th>Zone</th>
								<th className="text-center">Actions</th>
							</tr>
						</thead>
						<tbody>
							{residences.length > 0 &&
								residences.map((item, i) => (
									<tr key={item?._id}>
										<td>{i + 1}</td>
										<td>{item.name}</td>
										<td>{item?.location?.name}</td>
										<td>{item?.location?.zone?.name}</td>

										<td className="text-center">
											<Button
												variant="success"
												onClick={() =>
													navigate(`/admin/residences/details/${item.slug}`)
												}
											>
												View
											</Button>
										</td>
									</tr>
								))}
						</tbody>
					</table>
				)}
			</div>
		</>
	);
}
